// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__U1acZ","closeBtn":"Banner_closeBtn__bGXPt","swiper":"Banner_swiper__x97Gf","enabled":"Banner_enabled__zBIY2"};